import { Box } from "components/shared/box"

import styles from "./title-divider.module.scss"

type TitleDividerProps = {
  className?: string
}
export function TitleDivider({ className }: TitleDividerProps) {
  return (
    <Box className={`${styles["title-divider"]} w-36 ${className}`}>
      <Box className="w-full h-[2px] bg-primary"></Box>
      <Box className="w-20 h-[4px] bg-primary"></Box>
    </Box>
  )
}
